import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HighDetailedTextDoc = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="3 3 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <rect x="6.84479" y="14.4561" width="11.1458" height="0.898497" rx="0.449248" fill="#58AFFE" />
        <rect x="6.84479" y="16.3789" width="11.1458" height="0.898496" rx="0.449248" fill="#58AFFE" />
        <rect x="6.84479" y="18.3008" width="11.1457" height="0.898497" rx="0.449248" fill="#58AFFE" />
        <foreignObject x="-3.33786e-06" y="7.01324" width="27.3583" height="19.1552">
          <div
            style={{
              backdropFilter: 'blur(2.78px)',
              clipPath: 'url(#bgblur_0_clip_path)',
              height: '100%',
              width: '100%',
            }}
          />
        </foreignObject>
        <g filter="url(#filter0_di)">
          <path
            d="M5.64008 18.5068V15.8033C5.64008 14.0636 7.05038 12.6533 8.79008 12.6533H19.6967C20.8131 12.6533 21.7182 13.5584 21.7182 14.6749V18.5068C21.7182 19.6232 20.8131 20.5283 19.6967 20.5283H7.66161C6.54515 20.5283 5.64008 19.6232 5.64008 18.5068Z"
            fill="white"
            fillOpacity="0.67"
            shapeRendering="crispEdges"
          />
        </g>
        <rect x="8.98227" y="15.0557" width="11.1458" height="0.898496" rx="0.449248" fill="#58AFFE" />
        <rect x="8.98227" y="20.8252" width="11.1458" height="0.898497" rx="0.449248" fill="#58AFFE" />
        <rect x="8.98227" y="16.9785" width="11.1458" height="0.898497" rx="0.449248" fill="#58AFFE" />
        <rect x="8.98227" y="22.7471" width="11.1458" height="0.898497" rx="0.449248" fill="#58AFFE" />
        <rect x="8.98227" y="18.9023" width="11.1457" height="0.898497" rx="0.449248" fill="#58AFFE" />
        <foreignObject x="0.600033" y="7.01324" width="29.3458" height="23.997">
          <div
            style={{
              backdropFilter: 'blur(2.19px)',
              clipPath: 'url(#bgblur_1_clip_path)',
              height: '100%',
              width: '100%',
            }}
          />
        </foreignObject>
        <g filter="url(#filter1_di)">
          <path
            d="M8.22761 14.6408V22.2205C8.22761 23.9602 9.63792 25.3705 11.3776 25.3705H22.2842C23.4007 25.3705 24.3057 24.4654 24.3057 23.349V14.6749C24.3057 13.5584 23.4007 12.6533 22.2842 12.6533H6.24011C7.33778 12.6533 8.22761 13.5432 8.22761 14.6408Z"
            fill="white"
            fillOpacity="0.67"
            shapeRendering="crispEdges"
          />
        </g>
        <foreignObject x="0.896134" y="-2.44551" width="33.0379" height="35.9018">
          <div
            style={{
              backdropFilter: 'blur(4.04px)',
              clipPath: 'url(#bgblur_2_clip_path)',
              height: '100%',
              width: '100%',
            }}
          />
        </foreignObject>
        <g filter="url(#filter2_di)">
          <path
            d="M12.9913 5.64043L14.1198 5.64043L23.8264 5.64043C24.9428 5.64043 25.8479 6.5455 25.8479 7.66197L25.8479 21.6701C25.8479 23.7136 24.1913 25.3701 22.1479 25.3701L8.98227 25.3701C10.0799 25.3701 10.9698 24.4803 10.9698 23.3826L10.9698 7.66196C10.9698 6.5455 11.8748 5.64043 12.9913 5.64043Z"
            fill="white"
            fillOpacity="0.67"
            shapeRendering="crispEdges"
          />
        </g>
        <rect x="12.865" y="9.49902" width="11.1458" height="0.898496" rx="0.449248" fill="#58AFFE" />
        <rect x="12.865" y="15.2676" width="11.1458" height="0.898497" rx="0.449248" fill="#58AFFE" />
        <rect x="12.865" y="21.0342" width="11.1458" height="0.898497" rx="0.449248" fill="#58AFFE" />
        <rect x="12.865" y="11.4209" width="11.1458" height="0.898497" rx="0.449248" fill="#58AFFE" />
        <rect x="12.865" y="17.1895" width="11.1458" height="0.898496" rx="0.449248" fill="#58AFFE" />
        <rect x="12.865" y="22.9561" width="11.1458" height="0.898497" rx="0.449248" fill="#58AFFE" />
        <rect x="12.865" y="13.3447" width="11.1457" height="0.898497" rx="0.449248" fill="#58AFFE" />
        <rect x="12.865" y="19.1123" width="11.1457" height="0.898495" rx="0.449247" fill="#58AFFE" />
        <rect x="12.865" y="7.57617" width="7.88808" height="0.898496" rx="0.449248" fill="#58AFFE" />
        <defs>
          <filter
            id="filter0_di"
            x="-3.33786e-06"
            y="7.01324"
            width="27.3583"
            height="19.1552"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.404307" dy="0.404307" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
            <feBlend mode="normal" in2="shape" result="effect2_innerShadow" />
          </filter>
          <clipPath id="bgblur_0_clip_path" transform="translate(3.33786e-06 -7.01324)">
            <path d="M5.64008 18.5068V15.8033C5.64008 14.0636 7.05038 12.6533 8.79008 12.6533H19.6967C20.8131 12.6533 21.7182 13.5584 21.7182 14.6749V18.5068C21.7182 19.6232 20.8131 20.5283 19.6967 20.5283H7.66161C6.54515 20.5283 5.64008 19.6232 5.64008 18.5068Z" />
          </clipPath>
          <filter
            id="filter1_di"
            x="0.600033"
            y="7.01324"
            width="29.3458"
            height="23.997"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.404307" dy="0.404307" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
            <feBlend mode="normal" in2="shape" result="effect2_innerShadow" />
          </filter>
          <clipPath id="bgblur_1_clip_path" transform="translate(-0.600033 -7.01324)">
            <path d="M8.22761 14.6408V22.2205C8.22761 23.9602 9.63792 25.3705 11.3776 25.3705H22.2842C23.4007 25.3705 24.3057 24.4654 24.3057 23.349V14.6749C24.3057 13.5584 23.4007 12.6533 22.2842 12.6533H6.24011C7.33778 12.6533 8.22761 13.5432 8.22761 14.6408Z" />
          </clipPath>
          <filter
            id="filter2_di"
            x="0.896134"
            y="-2.44551"
            width="33.0379"
            height="35.9018"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.404307" dy="0.404307" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
            <feBlend mode="normal" in2="shape" result="effect2_innerShadow" />
          </filter>
          <clipPath id="bgblur_2_clip_path" transform="translate(-0.896134 2.44551)">
            <path d="M12.9913 5.64043L14.1198 5.64043L23.8264 5.64043C24.9428 5.64043 25.8479 6.5455 25.8479 7.66197L25.8479 21.6701C25.8479 23.7136 24.1913 25.3701 22.1479 25.3701L8.98227 25.3701C10.0799 25.3701 10.9698 24.4803 10.9698 23.3826L10.9698 7.66196C10.9698 6.5455 11.8748 5.64043 12.9913 5.64043Z" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

export default HighDetailedTextDoc
